<script>
import {
  getAllocatedSeats,
  getSeatsUsedOnTable,
  setOrdersForTable,
} from "@/common/assignments";
import AssignmentSelect from "@/common/components/AssignmentSelect.vue";

export default {
  name: "TablesTable",
  components: {
    AssignmentSelect,
  },
  props: {
    orderList: { type: Array, required: true },
    orders: { type: Array, required: true },
    tableList: { type: Array, required: true },
    tableStatuses: { type: [Array, Object], required: true },
  },
  emits: ["assigned", "edit"],
  computed: {
    tables() {
      const tables = [];
      this.tableList.forEach((t) => {
        const orders = this.orders
          .filter((o) => o.allocations.some((a) => a.table == t.tableId))
          .map((o) => o.number);
        tables.push({ table: t, orders: orders });
      });

      return tables;
    },
  },
  methods: {
    assignOrders(tableNumber, orderNumbers) {
      setOrdersForTable(this.orders, tableNumber, orderNumbers).forEach((o) =>
        this.$emit("assigned", o, tableNumber)
      );
    },
    editSeats(orderNumber, tableNumber) {
      const order = this.orderFor(orderNumber);
      if (order) {
        this.$emit("edit", order, tableNumber);
      }
    },
    orderFor(orderNumber) {
      return this.orders.find((o) => o.number == orderNumber);
    },
    seatsForOrder(orderNumber, tableNumber) {
      const order = this.orderFor(orderNumber);

      return order ? getAllocatedSeats(order, tableNumber) : 0;
    },
    seatsUsedOnTable(tableNumber) {
      return getSeatsUsedOnTable(this.orders, tableNumber);
    },
  },
};
</script>

<template>
  <table>
    <tr>
      <th>Table</th>
      <th>Capacity</th>
      <th>Status</th>
      <th>Orders</th>
    </tr>
    <tr v-for="table in tables" :key="table.table.tableId">
      <td>{{ table.table.tableId }}</td>
      <td
        :class="{
          'text-danger':
            seatsUsedOnTable(table.table.tableId) > table.table.capacity,
        }"
      >
        {{ seatsUsedOnTable(table.table.tableId) }} / {{ table.table.capacity }}
      </td>
      <td class="stored-items">
        <select v-model="table.table.currentStatus" class="single-select">
          <option value=" ">None</option>
          <option
            v-for="(label, value) in tableStatuses"
            :key="value"
            :value="value"
          >
            {{ label }}
          </option>
        </select>
      </td>
      <td class="stored-items">
        <AssignmentSelect
          :model-value="table.orders"
          :options="orderList"
          placeholder="Begin typing to assign order"
          :seats-for="
            (orderNumber) => seatsForOrder(orderNumber, table.table.tableId)
          "
          @input="assignOrders(table.table.tableId, $event)"
          @edit="editSeats($event, table.table.tableId)"
        />
      </td>
    </tr>
  </table>
</template>
